import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageManagerProvider } from './storage-manager/storage-manager';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(
    public translateService: TranslateService,
    public storageManager: StorageManagerProvider
  ) {


  }
  setLang(lang: string) {
    this.translateService.use(lang);
    this.translateService.setDefaultLang(lang);
    this.storageManager.set("lang", lang);
  }
  async useCurrentTranslation(){
    let lang = await this.storageManager.get("lang")
    if (!lang) {
      lang = "fa";
    }
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
  }
}
